import { ReactNode } from 'react';
import { MaterialSymbol, BodyText, withStyles } from 'vopay';
import styles from './InfoBanner.module.scss';

const cn = withStyles(styles);

export type InfoBannerProps = {
  children: ReactNode;
  colorScheme?: 'info' | 'error' | 'neutral';
};

export default function InfoBanner({ children, colorScheme = 'info' }: InfoBannerProps) {
  const iconColor = colorScheme === 'error' ? 'var(--vopayRed)' : 'var(--vopayBlue)';

  return (
    <div className={cn('banner', colorScheme === 'error' && 'error')}>
      <MaterialSymbol icon={colorScheme === 'error' ? 'error' : 'info'} size="20px" color={iconColor} fillAmount={1} />

      <BodyText
        size="sm"
        className={cn('bannerText', colorScheme === 'error' && 'errorText', colorScheme === 'neutral' && 'neutralText')}
      >
        {children}
      </BodyText>
    </div>
  );
}
